module.exports = __webpack_public_path__ + "media/images/proof_links/colored/qq-3896d19eed1bf5e0c2cb98678903f5a9.svg";